module.exports = __webpack_public_path__ + "media/images/jeroboam-narrow-ff4b42c5eb85fce1e2e2fccc5b2f58c6.svg";